module.exports = __webpack_public_path__ + "img/pr-2.cf12ecaa.png";